import { Injectable } from '@angular/core';
import { SearchCreditRiskProposalModel } from '../models/search-credit-risk-proposal.model';
import { CreditRiskProposalListModel } from '../models/credit-risk-proposal-list.model';
import { environment } from 'src/environments/environment';
import { Pageable } from 'src/app/shared/models/pageable.model';
import { HttpClient } from '@angular/common/http';
import { CreditRiskProposalHistoryModel } from '../models/compliance-proposal-history.model';
import { CreditRiskProposalDetailsModel, BasicDetailsModel, HistoryDetailsModel } from '../models/credit-risk-proposal-details.model';
import { Observable } from 'rxjs';
import { ComplianceProposalUpdateModel } from 'src/app/compliance-proposal-list/models/compliance-proposal-update.model';
import { CreditRiskProposalUpdateModel } from '../models/credit-risk-proposal-update.model';

@Injectable({
  providedIn: 'root'
})
export class CreditRiskProposalService {

  constructor(private http: HttpClient){}

  findPendingProposals(filter: SearchCreditRiskProposalModel) {

    let startDateQuery = '';
    let endDateQuery = '';
    let cpfQuery = '';
    let institutionQuery = '';
    let serviceContractQuery = '';
    let sizeQuery = '';
    let pageQuery = '';
    let statusQuery = '';

    if(filter){
      startDateQuery = filter.startDate ? `&start-date=${filter.startDate}` : '';
      endDateQuery = filter.endDate ? `&end-date=${filter.endDate}` : '';
      cpfQuery = filter && filter.cpfCnpj ? `&cpf-cnpj=${filter.cpfCnpj}` : '';
      institutionQuery = filter.institution ? `&institution=${filter.institution}` : '';
      serviceContractQuery = filter.serviceContract ? `&service-contract=${filter.serviceContract}` : '';
      sizeQuery = filter.size ? `&size=${filter.size}` : '';
      pageQuery = filter.page ? `&page=${filter.page}` : '';
      statusQuery = filter.status ? `&proposal-status=${filter.status}` : '';
    }

    return this.http.get<Pageable<CreditRiskProposalListModel[]>>(`${environment.apiUrls.creditRiskProposals}?1=1${startDateQuery}${endDateQuery}${cpfQuery}${institutionQuery}${serviceContractQuery}${sizeQuery}${pageQuery}${statusQuery}`);
  }

  findProposalHistory(filter: SearchCreditRiskProposalModel) {

    let startDateQuery = '';
    let endDateQuery = '';
    let cpfQuery = '';
    let institutionQuery = '';
    let serviceContractQuery = '';
    let sizeQuery = '';
    let pageQuery = '';
    let statusQuery = '';

    if(filter){
      startDateQuery = filter.startDate ? `&start-date=${filter.startDate}` : '';
      endDateQuery = filter.endDate ? `&end-date=${filter.endDate}` : '';
      cpfQuery = filter && filter.cpfCnpj ? `&cpf-cnpj=${filter.cpfCnpj}` : '';
      institutionQuery = filter.institution ? `&institution=${filter.institution}` : '';
      serviceContractQuery = filter.serviceContract ? `&service-contract=${filter.serviceContract}` : '';
      sizeQuery = filter.size ? `&size=${filter.size}` : '';
      pageQuery = filter.page ? `&page=${filter.page}` : '';
      statusQuery = filter.status ? `&proposal-status=${filter.status}` : '';
    }

    return this.http.get<Pageable<CreditRiskProposalHistoryModel[]>>(`${environment.apiUrls.creditRiskProposals}?1=1${startDateQuery}${endDateQuery}${cpfQuery}${institutionQuery}${serviceContractQuery}${sizeQuery}${pageQuery}${statusQuery}`);
  }

  setProposalObservation(proposalNumber: string, data: CreditRiskProposalUpdateModel) {
    return this.http.post<any>(`${environment.apiUrls.creditRiskObservationSet}${proposalNumber}`, data);
  }

  getProposalDetail(proposalNumber: string): Observable<CreditRiskProposalDetailsModel> {
    return this.http.get<CreditRiskProposalDetailsModel>(`${environment.apiUrls.complianceProposalDetail}/${proposalNumber}`);
  }
}
